module.exports = __webpack_public_path__ + "static/media/Kurt_Simon.bf33598c.webp";